import { render } from "./Trailers.vue?vue&type=template&id=9c12b656"
import script from "./Trailers.vue?vue&type=script&lang=js"
export * from "./Trailers.vue?vue&type=script&lang=js"

import "./Trailers.vue?vue&type=style&index=0&id=9c12b656&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__